/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Delete_Transcript_Aria_LabelInputs */

const en_event_delete_transcript_aria_label = /** @type {(inputs: Event_Delete_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this transcript event`)
};

const fr_event_delete_transcript_aria_label = /** @type {(inputs: Event_Delete_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer cet evenement de transcription`)
};

const de_event_delete_transcript_aria_label = /** @type {(inputs: Event_Delete_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Transkript löschen`)
};

const it_event_delete_transcript_aria_label = /** @type {(inputs: Event_Delete_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina questo evento di trascrizione`)
};

const ru_event_delete_transcript_aria_label = /** @type {(inputs: Event_Delete_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить это событие из стенограммы`)
};

const es_event_delete_transcript_aria_label = /** @type {(inputs: Event_Delete_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar este evento de transcripción`)
};

const zh_cn2_event_delete_transcript_aria_label = /** @type {(inputs: Event_Delete_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除此转录事件`)
};

const ja_event_delete_transcript_aria_label = /** @type {(inputs: Event_Delete_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このトランスクリプトイベントを削除`)
};

const hi_event_delete_transcript_aria_label = /** @type {(inputs: Event_Delete_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस ट्रांसक्रिप्ट इवेंट को हटाएँ`)
};

const pt_pt2_event_delete_transcript_aria_label = /** @type {(inputs: Event_Delete_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir este evento de transcrição`)
};

/**
* | output |
* | --- |
* | "Delete this transcript event" |
*
* @param {Event_Delete_Transcript_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_delete_transcript_aria_label = /** @type {((inputs?: Event_Delete_Transcript_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Delete_Transcript_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_delete_transcript_aria_label(inputs)
	if (locale === "de") return de_event_delete_transcript_aria_label(inputs)
	if (locale === "it") return it_event_delete_transcript_aria_label(inputs)
	if (locale === "ru") return ru_event_delete_transcript_aria_label(inputs)
	if (locale === "es") return es_event_delete_transcript_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_delete_transcript_aria_label(inputs)
	if (locale === "ja") return ja_event_delete_transcript_aria_label(inputs)
	if (locale === "hi") return hi_event_delete_transcript_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_delete_transcript_aria_label(inputs)
	return en_event_delete_transcript_aria_label(inputs)
});